import { createSelector } from "@reduxjs/toolkit";

export const headerMenuCountersSelector = createSelector<[(state: LSStore.State) => LSStore.IHeaderMenuCountersViewModel], LSStore.IHeaderMenuCountersViewModel>(state => state.headerMenuCounters.value, x => x);
